import React, { useState, useEffect } from 'react';
import {
  Badge, HStack, Popover, PopoverTrigger, PopoverContent, PopoverBody,
  Text, VStack,
} from '@chakra-ui/react';
import { FiEye, FiMousePointer } from 'react-icons/fi';
import { supabase, isSupabaseConfigured } from '../../../utils/supabase';

let tableExists = true;

export default function EmailTrackingBadge({ activityId }) {
  const [stats, setStats] = useState(null);
  const [details, setDetails] = useState([]);

  useEffect(() => {
    if (!activityId || !isSupabaseConfigured() || !tableExists) return;

    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase
          .from('crm_email_tracking')
          .select('event_type, created_at, link_url')
          .eq('activity_id', activityId)
          .order('created_at', { ascending: false });

        if (error?.code === '42P01' || error?.message?.includes('404')) {
          tableExists = false;
          return;
        }
        if (cancelled || error || !data) return;

        const opens = data.filter(e => e.event_type === 'open').length;
        const clicks = data.filter(e => e.event_type === 'click').length;
        setStats({ opens, clicks });
        setDetails(data.slice(0, 10));
      } catch (err) {
        tableExists = false;
      }
    })();

    return () => { cancelled = true; };
  }, [activityId]);

  if (!stats || (stats.opens === 0 && stats.clicks === 0)) return null;

  return (
    <Popover trigger="hover" placement="top">
      <PopoverTrigger>
        <HStack spacing={2} mt={1} cursor="pointer">
          {stats.opens > 0 && (
            <Badge colorScheme="green" variant="subtle" fontSize="xs" display="flex" alignItems="center" gap={1}>
              <FiEye size={10} /> Opened {stats.opens}x
            </Badge>
          )}
          {stats.clicks > 0 && (
            <Badge colorScheme="blue" variant="subtle" fontSize="xs" display="flex" alignItems="center" gap={1}>
              <FiMousePointer size={10} /> {stats.clicks} click{stats.clicks !== 1 ? 's' : ''}
            </Badge>
          )}
        </HStack>
      </PopoverTrigger>
      <PopoverContent w="280px">
        <PopoverBody>
          <VStack align="stretch" spacing={1} fontSize="xs">
            {details.map((d, i) => (
              <HStack key={i} justify="space-between">
                <Text>
                  {d.event_type === 'open' ? 'Opened' : 'Clicked'}
                  {d.link_url ? `: ${(() => { try { return new URL(d.link_url).hostname; } catch { return d.link_url; } })()}` : ''}
                </Text>
                <Text color="gray.500">
                  {new Date(d.created_at).toLocaleString()}
                </Text>
              </HStack>
            ))}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
